export default "__VITE_ASSET__04cf647a__"